import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ReportsService {
    onReportIdLoaded = new Subject<string>();

    setLoadedReportId(reportId: string): void {
        this.onReportIdLoaded.next(reportId);
    }
}
